<template>
  <v-card
    :class="item.status === 'Active' ? 'my-2' : ''"
    :flat="item.status === 'Active' ? false : true">
    <!-- <v-card-title primary-title> -->
   
    <v-card-text>
      <div>
        <v-layout
          row
          wrap>
          <v-flex
            xs6
            class="text-xs-left"
            :class="item.status === 'Active' ? 'subheading font-weight-bold' : ''">
            {{ item.status }} 
          </v-flex>
          <!-- <span class="caption">{{ item.order }}</span> -->
          <v-flex
            xs6
            class="grey--text text-xs-right">
            {{ index + 1 }}. 
          </v-flex>
              
          <!-- <v-flex
            xs12
            class="mt-1">
            <span>{{ item.text }}</span>
          </v-flex> -->
          <v-flex
            xs12
            class="mt-1">
            <div class="font-italic">
              {{ item.text }}
            </div>
            <div
              v-for="(info, ind) in item.infos"
              :key="ind">
              - {{ info }}
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-card-text>
    <!-- <v-card-actions

      v-if="!show"
      class="my-0 py-0">
      <v-spacer></v-spacer>
      <v-btn
        small
        icon
        @click="show = !show">
        <v-icon small>
          {{ show ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}
        </v-icon>
      </v-btn>
    </v-card-actions> -->
    <!-- <v-divider></v-divider> -->
    <!-- </v-card-title> -->
    <v-divider
      v-if="item.status !== 'Active'"
      class="mx-3"></v-divider>
  </v-card>
</template>



<script>

export default {
  props: {
    item: { type: Object, default: null },
    index: { type: Number, default: 0 }
  },
  data: () => ({
  }),
  
  
  
}
</script>
